module.exports = __webpack_public_path__ + "static/media/progress-report.6a37e108.svg";